var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-sticky tw-bottom-0 tw-z-10 tw-flex-initial tw-transform tw-bg-white tw-px-2 tw-shadow-md tw-transition-all tw-duration-200 tw-ease-in-out xl:tw-px-8 xl:tw-py-4"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }